import componentHelper from '../../modules/component_helper.js';

angular.module('vastdesk').
  component('campaignTilesScreenDeduplication',  {
    bindings: {
      formName: '@',
      formId: '@',
      tilesScreenDeduplication: '<',
      maxBidsPerScreen: '<'
    },
    template: require("../templates/campaignTilesScreenDeduplication.html"),
    controllerAs: '$campaignTilesScreenDeduplicationCtrl',
    controller: ['$rootScope', function($rootScope) {

      var self = this;

      this.attributeEnabledMappings = componentHelper.attributeEnabledMappings();

      this.setTilesScreenDeduplication = function(val) {
        self.tilesScreenDeduplication = val;
      };
    }]
});
